/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Control_Faq_1_AInputs */

const en_control_faq_1_a = /** @type {(inputs: Control_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. This is an independent fan-made utility site.`)
};

const zh_control_faq_1_a = /** @type {(inputs: Control_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不是。本站是独立制作的玩家工具与攻略站，与 Remedy Entertainment 没有官方隶属关系。`)
};

/**
* | output |
* | --- |
* | "No. This is an independent fan-made utility site." |
*
* @param {Control_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const control_faq_1_a = /** @type {((inputs?: Control_Faq_1_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Control_Faq_1_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_control_faq_1_a(inputs)
	return zh_control_faq_1_a(inputs)
});
export { control_faq_1_a as "control.faq.1.a" }